module.exports = __webpack_public_path__ + "img/TAPON DE PUA.c34fe42b.jpg";